import { render, staticRenderFns } from "./FormKioskBannerType.vue?vue&type=template&id=faf0353a&"
import script from "./FormKioskBannerType.vue?vue&type=script&lang=js&"
export * from "./FormKioskBannerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('faf0353a')) {
      api.createRecord('faf0353a', component.options)
    } else {
      api.reload('faf0353a', component.options)
    }
    module.hot.accept("./FormKioskBannerType.vue?vue&type=template&id=faf0353a&", function () {
      api.rerender('faf0353a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kiosk-device/form/form-kiosk-device-banner-type/FormKioskBannerType.vue"
export default component.exports